import { DjangoTimeStamped, TimeStamped } from '../django';
import { DjangoEmployee, Employee } from '../employee';
import { bindData, bindDjangoData } from '../helpers/object';

export class Campaign {
  id = '';
  campaignType = CampaignType.DEFAULT;
  bonusAmount = 0;
  redeemLimit = 0;
  startDate = new Date();
  endDate = new Date();

  constructor(data: string | Campaign | any = {}) {
    if (typeof data === 'string') {
      bindDjangoData<Campaign, DjangoCampaign>(this, { id: data });
    } else if (data instanceof Campaign) {
      bindData<Campaign>(this, data);
    } else {
      bindDjangoData(this, data);
    }
  }
}

export enum CampaignType {
  MGM = 'MGM',
  DEFAULT = 'DEFAULT'
}

export interface DjangoCampaign {
  id: string;
  campaign_type?: string;
  bonus_amount?: number;
  redeem_limit?: number;
  start_date?: string;
  end_date?: string;
}

export function parseCampaign(data: string | Campaign | DjangoCampaign) {
  if (data) {
    return new Campaign(data);
  } else {
    return undefined;
  }
}

export class CampaignRedeem implements TimeStamped {
  activatedEmployee = new Employee();
  bonusAmount = 0;
  created = new Date();
  modified = new Date();

  constructor(data: string | CampaignRedeem | any = {}) {
    if (data instanceof CampaignRedeem) {
      bindData<CampaignRedeem>(this, data);
    } else {
      bindDjangoData<CampaignRedeem, DjangoCampaignRedeem>(this, data);
    }
  }
}

export interface DjangoCampaignRedeem extends DjangoTimeStamped {
  id: string;
  activated_employee: DjangoEmployee;
  bonus_amount: number;
};

export function parseCampaignRedeem(data: CampaignRedeem | DjangoCampaignRedeem) {
  if (data) {
    return new CampaignRedeem(data);
  } else {
    return undefined;
  }
}
